import { createAction } from '../../../../store.model';
import { ActionType } from '../event-centre-dialog.action';

export interface SelectCategory {
    categoryId: string;
    loadItems?: boolean;
}

export const selectCategory = createAction<ActionType, SelectCategory>(
    ActionType.NOTI__EC__SELECT_CATEGORY,
);
